import { defineMessages } from 'react-intl-next';

export const messages: {
	noResultsPrimary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsSecondary: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsSecondaryFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsClearFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noResultsPrimary: {
		id: 'no_results_primary',
		defaultMessage: "We couldn't find anything matching your search",
		description: 'Message shown when search request returns no results',
	},
	noResultsSecondary: {
		id: 'no_results_secondary_no_filters',
		defaultMessage: 'Try again with a different term.',
		description: 'Additional message to prompt users to try searching with a new query',
	},
	noResultsSecondaryFilters: {
		id: 'no_results_secondary_some_filters_applied',
		defaultMessage: 'Looks like you have some filters applied. You could try clearing them.',
		description: 'Additional message to prompt users to try searching without filters',
	},
	noResultsClearFilters: {
		id: 'no_results_clear_filters',
		defaultMessage: 'Clear filters',
		description: 'Button text to clear filters when no results are found',
	},
});
